import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getValuesFromLocalstorage } from '../../Helpers';

const AdminRoute = () => {
  const userDetails = getValuesFromLocalstorage('userDetails');
  
  // Only ADMIN users can access these routes
  const isAdmin = userDetails?.acctType === "ADMIN";
  
  console.log("Admin route check:", { 
    userDetails, 
    isAdmin,
    pathname: window.location.pathname
  });
  
  // If not admin, redirect to dashboard
  return isAdmin ? <Outlet /> : <Navigate to="/" />;
};

export default AdminRoute; 